import { Chip } from '@mui/material';
import React from 'react';

export default function StatusInTable({ StatusText, StatusColor = 'black' }) {
  let textColor = StatusColor != 'white' && StatusColor != '' ? 'white' : 'black';
  return (
    <Chip sx={{
      height: 'auto',
      '& .MuiChip-label': {
        display: 'flex',
        whiteSpace: 'normal',
        textAlign: 'center',
        minHeight: '25px',
        alignItems: 'center'
      },
    }} style={{ width : '120px' ,  background: StatusColor, color: textColor }} label={StatusText} />
  )
}
